export const youtube = {
  wrapper: {
    alignSelf: 'stretch',
    widht: '100%'
  },
};
